<template>
    <div class="designerpage">

        <igdoors-designer-question-door-range
            :fabricator="fabricator"
            v-model:target="door.attr.door_range"
            :reference_on="reference_on"
            :ranges="ranges"
            :show_range_names="false"
            :defaults="defaults()"
            title="Choose a Door Range"
            :designer_range_section_banners="designer_range_section_banners"
        ></igdoors-designer-question-door-range>

        <designer-question-panel-category-with-thumbnails
            v-if="show_panel_category_question"
            :fabricator="fabricator"
            :door-range="door.attr.door_range"
            :title="'Door Thickness'"
            v-model:target="door.attr.panel_category"
            :modifier_class="'_wide'"
        ></designer-question-panel-category-with-thumbnails>

      <igdoors-designer-question-secured-by-design
        :fabricator="fabricator"
        :category="door.attr.panel_category"
        v-model:target="door.attr.secured_by_design"
      ></igdoors-designer-question-secured-by-design>

        <igdoors-designer-question-select-frame-style
            v-show="!slab_only"
            :fabricator="fabricator"
            :is-firedoor="is_firedoorrange"
            :type-range="door.attr.door_range"
            v-model:target="door.attr.frame_style"
            :frame-material="door.attr.frame_material"
            :activate_panels_img_src="'/images/igdoors/activatepanelsimg.jpg'"
            :panel-category="door.attr.panel_category"
        ></igdoors-designer-question-select-frame-style>

        <div class="designeroption">
            <designer-question-hinge-side :fabricator="fabricator"
                                          v-model:target="door.attr.hinge_side"></designer-question-hinge-side>
        </div>
        <div class="designeroption">
            <designer-question-opening-direction :fabricator="fabricator"
                                                 v-model:target="door.attr.opening_direction"></designer-question-opening-direction>
        </div>

            <designer-question-select-door
                :fabricator="fabricator"
                :secured-by-design="door.attr.secured_by_design"
                :door-range="door.attr.door_range"
                :category="door.attr.panel_category"
                v-model:target="door.attr.slab"
            ></designer-question-select-door>

            <designer-question-frame-material
                v-show="false"
                :slab="door.attr.slab"
                :fabricator="fabricator"
                v-model:target="door.attr.frame_material"
            ></designer-question-frame-material>

        <designer-question-colour-range
            title="Colour Ranges"
            :fabricator="fabricator"
            :slab="door.attr.slab"
            :type-range="door.attr.door_range"
            :category="slab_only ? door.attr.panel_category : 0"
            v-model:target="door.attr.colour_range"
        ></designer-question-colour-range>

        <div class="designeroption" data-designer-component-id="door_colour">
            <h3>Choose Your Door Colour</h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#dc-tabs-1">External Colour</a></li>
                    <li><a href="#dc-tabs-2">Internal Colour</a></li>
                </ul>
                <div id="dc-tabs-1">
                    <designer-question-door-colour-external :fabricator="fabricator" :slab="door.attr.slab"
                                                               :door-range="door.attr.door_range"
                                                               :colour-range="door.attr.colour_range"
                                                               v-model:target="door.attr.external_colour"></designer-question-door-colour-external>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.external_colour"
                                                  title="External Door Colour"
                                                  label="Please enter the RAL Classic colour number you require for your External Door Colour:"
                                                  v-model:target="door.attr.external_colour_ral"></designer-question-ral-colour>
                </div>
                <div id="dc-tabs-2">
                    <designer-question-door-colour-internal :fabricator="fabricator" :slab="door.attr.slab"
                                                               :door-range="door.attr.door_range"
                                                               :colour-range="door.attr.colour_range"
                                                               :external-colour="door.attr.external_colour"
                                                               v-model:target="door.attr.door_colour_internal"></designer-question-door-colour-internal>

                    <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.door_colour_internal"
                                                  title="Internal Door Colour"
                                                  label="Please enter the RAL Classic colour number you require for your Internal Door Colour:"
                                                  v-model:target="door.attr.door_colour_internal_ral"></designer-question-ral-colour>
                </div>
            </div>
        </div>

        <div class="designeroption" data-designer-component-id="frame_colour" v-show="!slab_only">
            <h3>Pick Your Frame Colour</h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#tabs-1">External Colour</a></li>
                    <li><a href="#tabs-2">Internal Colour</a></li>
                </ul>
                <div id="tabs-1">
                    <designer-question-frame-colour-external :fabricator="fabricator"
                                                                :frame-material="door.attr.frame_material"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                :door-range="door.attr.door_range"
                                                                :colour-range="door.attr.colour_range"
                                                                :category="door.attr.panel_category"
                                                                v-model:target="door.attr.frame_colour_external"></designer-question-frame-colour-external>
                </div>
                <div id="tabs-2">
                    <designer-question-frame-colour-internal :fabricator="fabricator"
                                                                :frame-colour-external="door.attr.frame_colour_external"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                :door-range="door.attr.door_range"
                                                                :colour-range="door.attr.colour_range"
                                                                :category="door.attr.panel_category"
                                                                v-model:target="door.attr.frame_colour_internal"></designer-question-frame-colour-internal>
                </div>
            </div>
        </div>

        <div v-show="technical_should_show">
            <wb-designer-question-technical-profile :fabricator="fabricator"
                                                    :frame-colour-internal="door.attr.frame_colour_internal"
                                                    :frame-colour-external="door.attr.frame_colour_external"
                                                    :frame-material="door.attr.frame_material"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                    :door-range="door.attr.door_range"
                                                    :opening-direction="door.attr.opening_direction"
                                                    :panel-category="door.attr.panel_category"
                                                    v-model:target="door.attr.profile"></wb-designer-question-technical-profile>
        </div>

        <!-- <div>
            <designer-question-door-glass-laminated :fabricator="fabricator"
                                                       title="Laminated Glass:"
                                                       :slab="door.attr.slab"
                                                       :frame-style="door.attr.frame_style"
                                                       :side-panels="door.attr.side_panels"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       :is-firedoor="is_firedoorrange"
                                                       v-model:target="door.attr.laminated_glass"></designer-question-door-glass-laminated>
        </div> -->

        <div>
            <designer-question-glass-design :fabricator="fabricator"
                                               v-model:target="door.attr.glass_design"
                                               :laminated-glass="door.attr.laminated_glass"
                                               :door-range="door.attr.door_range"
                                               :slab="door.attr.slab"></designer-question-glass-design>

            <designer-question-glass-text v-model:target="door.attr.glass_text"
                                             :glass-design="door.attr.glass_design"></designer-question-glass-text>

            <truedor-designer-question-glass-colour-selector :fabricator="fabricator"
                                                             v-model:target="door.attr.glass_colours"
                                                             title="Choose Your Glass Colours"
                                                             :slab="door.attr.slab"
                                                             :glass-design="door.attr.glass_design"></truedor-designer-question-glass-colour-selector>
        </div>

        <designer-question-glass-backing-design :fabricator="fabricator"
                                                   v-model:target="door.attr.glass_backing_design"
                                                   :slab="door.attr.slab"
                                                   :door-range="door.attr.door_range"
                                                   :glass-design="door.attr.glass_design"></designer-question-glass-backing-design>

        <designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                      v-model:target="door.attr.side_panels"
                                                      :door-range="door.attr.door_range"
                                                      :frame-style="door.attr.frame_style"
                                                      :frame-profile="door.attr.profile"
                                                      :panel-category="door.attr.panel_category"
                                                      :frame-material="door.attr.frame_material"
                                                      :laminated-glass="door.attr.laminated_glass"
                                                      :frame-colour-internal="door.attr.frame_colour_internal"
                                                      :frame-colour-external="door.attr.frame_colour_external"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :slab="door.attr.slab"
                                                      :measurements.sync="door.attr.measurements"></designer-question-select-frame-sidepanels>


        <div>
            <designer-question-hardware-colour :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_colour"
                                                  :sbd="door.attr.secured_by_design"
                                                  :slab="door.attr.slab"
                                                  :door-range="door.attr.door_range"
                                                  :profile="door.attr.profile"
                                                  :opening-direction="door.attr.opening_direction"></designer-question-hardware-colour>

            <designer-question-hardware-handle :fabricator="fabricator"
                                                  v-model:target="door.attr.hardware_handle"
                                                  :slab="door.attr.slab"
                                                  :secured-by-design="door.attr.secured_by_design"
                                                  :opening-direction="door.attr.opening_direction"
                                                  :hardware-colour="door.attr.hardware_colour"
                                                  :door-range="door.attr.door_range"
                                                  :profile="door.attr.profile"></designer-question-hardware-handle>

          <designer-question-hardware-handle-split-spindle
            v-show="technical_should_show" :fabricator="fabricator"
            v-model:target="door.attr.hardware_handle_split_spindle"
            :hardware-handle="door.attr.hardware_handle"
            :slab="door.attr.slab"
          ></designer-question-hardware-handle-split-spindle>

          <designer-question-hardware-handle-internal :fabricator="fabricator"
                                                      v-model:target="door.attr.hardware_handle_internal"
                                                      :slab="door.attr.slab"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :opening-direction="door.attr.opening_direction"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :door-range="door.attr.door_range"
                                                      :profile="door.attr.profile"
                                                      :handle-external="door.attr.hardware_handle"></designer-question-hardware-handle-internal>

        </div>
        <div>
            <designer-question-hardware-escutcheon :fabricator="fabricator"
                                                      v-model:target="door.attr.hardware_escutcheon"
                                                      :slab="door.attr.slab"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :hardware-handle="door.attr.hardware_handle"
                                                      :door-range="door.attr.door_range"
                                                      :hardware-handle-internal="door.attr.hardware_handle_internal"
                                                      :profile="door.attr.profile"></designer-question-hardware-escutcheon>

            <designer-question-hardware-escutcheon-position :fabricator="fabricator"
                                                            v-model:target="door.attr.hardware_escutcheon_pos"
                                                            :slab="door.attr.slab"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-escutcheon="door.attr.hardware_escutcheon"></designer-question-hardware-escutcheon-position>
        </div>
        <div>
            <designer-question-hardware-lock :fabricator="fabricator"
                                             v-model:target="door.attr.hardware_lock"
                                             :secured-by-design="door.attr.secured_by_design"
                                             :hinge-side="door.attr.hinge_side"
                                             :slab="door.attr.slab"
                                             :frame-material="door.attr.frame_material"
                                             :hardware-handle="door.attr.hardware_handle"
                                                :opening_direction="door.attr.opening_direction"
                                             :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                     :door-range="door.attr.door_range"></designer-question-hardware-lock>

            <designer-question-hardware-cylinder v-show="technical_should_show" :fabricator="fabricator"
                                                    title="Choose Your Cylinder"
                                                    v-model:target="door.attr.hardware_cylinder"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-lock="door.attr.hardware_lock"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :opening_direction="door.attr.opening_direction"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :door-range="door.attr.door_range"></designer-question-hardware-cylinder>
        </div>

        <div>
            <designer-question-hardware-letterbox :fabricator="fabricator"
                                                     v-model:target="door.attr.hardware_letterbox"
                                                     :secured-by-design="door.attr.secured_by_design"
                                                     :slab="door.attr.slab"
                                                     :side-panels="door.attr.side_panels"
                                                     :frame-id="door.attr.frame_style.frame_id"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :hardware-colour="door.attr.hardware_colour"
                                                     :door-range="door.attr.door_range"></designer-question-hardware-letterbox>

            <designer-question-hardware-letterbox-cowl :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_letterbox_cowl"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-letterplate="door.attr.hardware_letterbox"
                                                    :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-letterbox-cowl>

            <designer-question-hardware-letterbox-position :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_letterbox_pos"
                                                           :slab="door.attr.slab"
                                                           :side-panels="door.attr.side_panels"
                                                           :frame-id="door.attr.frame_style.frame_id"
                                                           :frame-material="door.attr.frame_material"
                                                           :hardware-letterbox="door.attr.hardware_letterbox"
                                                           :door-range="door.attr.door_range"></designer-question-hardware-letterbox-position>
        </div>
        <div>
            <designer-question-hardware-knocker :fabricator="fabricator"
                                                   v-model:target="door.attr.hardware_knocker"
                                                   :slab="door.attr.slab"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :hardware-spyhole="door.attr.hardware_spy_hole"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   :door-range="door.attr.door_range"></designer-question-hardware-knocker>

            <designer-question-hardware-knocker-position :fabricator="fabricator"
                                                         v-model:target="door.attr.hardware_knocker_pos"
                                                         :slab="door.attr.slab"
                                                         :frame-material="door.attr.frame_material"
                                                         :hardware-knocker="door.attr.hardware_knocker"
                                                         :door-range="door.attr.door_range"></designer-question-hardware-knocker-position>
        </div>

        <div>
            <designer-question-hardware-spy-hole :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_spy_hole"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :glass-design="door.attr.glass_design"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-knocker="door.attr.hardware_knocker"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :door-range="door.attr.door_range"></designer-question-hardware-spy-hole>

            <designer-question-hardware-spy-hole-position :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_spy_hole_pos"
                                                          :slab="door.attr.slab"
                                                          :frame-material="door.attr.frame_material"
                                                          :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                          :door-range="door.attr.door_range"></designer-question-hardware-spy-hole-position>
        </div>

        <div class="designeroption">
            <designer-question-hardware-numerals :fabricator="fabricator"
                                                 v-model:target="door.attr.numerals"
                                                 :slab="door.attr.slab"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 title="Numerals"></designer-question-hardware-numerals>
        </div>

        <div>
            <designer-question-hardware-security-chain :fabricator="fabricator"
                                                       :secured-by-design="door.attr.secured_by_design"
                                                       v-model:target="door.attr.hardware_security_chain"
                                                       :hardware-colour="door.attr.hardware_colour"
                                                          :door-range="door.attr.door_range"></designer-question-hardware-security-chain>
        </div>

        <div class="designeroption">
            <designer-question-hardware-hinge-bolts v-show="technical_should_show" :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_hinge_bolts"
                                                    :hardware-hinge="door.attr.hardware_hinge"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :title="'Dog Bolts: '"
            ></designer-question-hardware-hinge-bolts>
        </div>

        <div v-show="technical_should_show">
            <designer-question-restrictor :fabricator="fabricator"
                                          v-model:target="door.attr.restrictor"
                                          :opening-direction="door.attr.opening_direction"
                                          :slab="door.attr.slab"
            ></designer-question-restrictor>
            <div>
                <designer-question-closer :fabricator="fabricator"
                                          v-model:target="door.attr.closer"></designer-question-closer>
            </div>
        </div>

        <div v-show="technical_should_show && !slab_only">
            <designer-question-addons :fabricator="fabricator"
                                      v-model:target="door.attr.addons"
                                      :frame-profile="door.attr.profile"
                                      :frame-colour-internal="door.attr.frame_colour_internal"
                                      :frame-colour-external="door.attr.frame_colour_external"
                                      :panel-category="door.attr.panel_category"
            ></designer-question-addons>
        </div>

        <designer-question-technical-threshold v-show="technical_should_show && !slab_only" :fabricator="fabricator"
                                                  title="Choose Your Threshold"
                                                  v-model:target="door.attr.threshold"
                                                  :frame-colour-internal="door.attr.frame_colour_internal"
                                                  :frame-colour-external="door.attr.frame_colour_external"
                                                  :opening-direction="door.attr.opening_direction"
                                                  :frame-profile="door.attr.profile"
                                                  :cill="door.attr.cill"
                                                  :door-range="door.attr.door_range"></designer-question-technical-threshold>

        <div class="designeroption" v-show="technical_should_show && !slab_only">
            <h3>Select Any Required Sills</h3>
            <designer-question-technical-cill :fabricator="fabricator"
                                              v-model:target="door.attr.cill"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :opening-direction="door.attr.opening_direction"
                                              :frame-profile="door.attr.profile"
                                              :threshold="door.attr.threshold"
                                              :door-range="door.attr.door_range"
                                              :category="door.attr.panel_category"
                                              :component_id="'cill'"
                                              :show_cill_horn_text="false"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="left_flag_sill" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.left_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :title="'Left Sidepanel Flag'"
                                              :component_id="'left_flag_cill'"
                                              :show_cill_horn_text="false"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="right_flag_sill" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.right_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :title="'Right Sidepanel Flag'"
                                              :component_id="'right_flag_cill'"
                                              :show_cill_horn_text="false"
            ></designer-question-technical-cill>
        </div>

        <div>
            <designer-question-door-drip-colour v-show="technical_should_show" :fabricator="fabricator"
                                                   title="Choose A Weatherbar colour"
                                                   :external-colour="door.attr.external_colour"
                                                   v-model:target="door.attr.door_drip_colour"
                                                   :frame-profile="door.attr.profile"></designer-question-door-drip-colour>
        </div>

        <div>
            <designer-question-measurements v-show="technical_should_show" title="Enter Your Required Measurements"
                                                    :fabricator="fabricator"
                                                    :slab="door.attr.slab"
                                                    :external-colour="door.attr.external_colour"
                                                    :internal-colour="door.attr.door_colour_internal"
                                                    :frame-profile="door.attr.profile"
                                                    :threshold="door.attr.threshold"
                                                    :frame-id="door.attr.frame_style.frame_id"
                                                    :side-panels="door.attr.side_panels"
                                                    :addons="door.attr.addons"
                                                    :cill="door.attr.cill"
                                                    :hardware-lock="door.attr.hardware_lock"
                                                    :hardware-hinge="door.attr.hardware_hinge"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-knocker="door.attr.hardware_knocker"
                                                    :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                    :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                    :hardware-letterbox="door.attr.hardware_letterbox"
                                                    :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                                    :door-range="door.attr.door_range"
                                                    :mdd="mdd"
                                                    :technical_should_show="technical_should_show"
                                                    :door-width-and-height-label="slab_only ? 'Door Width x Height' : 'Overall Frame Width x Height'"
                                                    v-model:target="door.attr.measurements"></designer-question-measurements>
        </div>

        <div class="designeroption" v-if="reference_on" data-designer-component-id="reference">
            <h3>Enter A Door Reference</h3>
            <div class="stylesoption">
                <div class="form-group">
                    <input dusk="door_reference" type="text" v-model="door.attr.reference" class="form-control">
                </div>
            </div>
        </div>
        <input v-else dusk="door_reference" type="hidden" v-model="door.attr.reference" class="form-control" value="Retail Door">

      <designer-question-notes v-model:target="door.attr.notes" v-show="false"></designer-question-notes>

      <designer-navigation
          v-if="show_navigation"
          :visible_designer_configurator_components="visible_designer_configurator_components"
          transition="designer-navigation"
      ></designer-navigation>

    </div>

</template>

<script type="text/ecmascript-6">
import DoorConfigurator from "../DoorConfigurator.vue";

export default {
    mixins: [
        DoorConfigurator
    ],
    computed: {
        slab_only() {
            return this.door.attr.door_range === 192;
        },
        is_firedoorrange() {
            return false;
        },
        show_panel_category_question() {
            return [181, 187, 188, 182, 189, 190, 191].includes(this.door.attr.door_range);
        }
    },
    methods: {
        defaults() {
            return {
                181: {
                    "attr": {
                        "fabricator": 33,
                        "door_range": 181,
                        "colour_range": 33,
                        "frame_colour_external": 1136,
                        "frame_colour_internal": 1136,
                        "door_colour_internal": 1,
                        "door_drip_colour": 1,
                        "external_colour": 1,
                        "frame_material": 1,
                        "hardware_colour": 45951,
                        "hardware_handle": 3687,
                        "hardware_hinge": 3699,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 3129,
                        "frame_style": {"frame_id": 1, "checkedPanels": []},
                        "laminated_glass": 2,
                        "hardware_lock": 3726,
                        "hardware_cylinder": 3677,
                        "hardware_security_chain": 317,
                        "hardware_hinge_bolts": 3978,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 144640664,
                        "threshold": 144640665,
                        "side_panels": {
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left": 1,
                            "right": 1,
                            "top_panel_glass_id": 10,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": 10,
                            "right_panel_glass_id": 10
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                        "cill": 144640669,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "glass_colours": null,
                        "panel_category": 77,
                    }
                },
                182: {
                    "attr": {
                        "fabricator": 33,
                        "door_range": 182,
                        "colour_range": 34,
                        "frame_colour_external": 1149,
                        "frame_colour_internal": 1149,
                        "external_colour": 1181,
                        "door_colour_internal": 1181,
                        "door_drip_colour": 1,
                        "frame_material": 1,
                        "hardware_colour": 45951,
                        "hardware_handle": 3687,
                        "hardware_hinge": 3699,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 3166,
                        "frame_style": {"frame_id": 1, "checkedPanels": []},
                        "laminated_glass": 2,
                        "hardware_lock": 3726,
                        "hardware_cylinder": 3677,
                        "hardware_security_chain": 317,
                        "hardware_hinge_bolts": 3978,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 144640664,
                        "threshold": 144640665,
                        "side_panels": {
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left": 1,
                            "right": 1,
                            "top_panel_glass_id": 10,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": 10,
                            "right_panel_glass_id": 10
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                        "cill": 144640669,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "glass_colours": null
                    }
                },
                187: {
                    "attr": {
                        "fabricator": 33,
                        "door_range": 187,
                        "colour_range": 33,
                        "frame_colour_external": 1136,
                        "frame_colour_internal": 1136,
                        "door_colour_internal": 1,
                        "door_drip_colour": 1,
                        "external_colour": 1,
                        "frame_material": 1,
                        "hardware_colour": 45951,
                        "hardware_handle": 3687,
                        "hardware_hinge": 3699,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 3086,
                        "frame_style": {"frame_id": 1, "checkedPanels": []},
                        "laminated_glass": 2,
                        "hardware_lock": 3726,
                        "hardware_cylinder": 3677,
                        "hardware_security_chain": 317,
                        "hardware_hinge_bolts": 3978,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 144640664,
                        "threshold": 144640665,
                        "side_panels": {
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left": 1,
                            "right": 1,
                            "top_panel_glass_id": 10,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": 10,
                            "right_panel_glass_id": 10
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                        "cill": 144640669,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "glass_colours": null
                    }
                },
                188: {
                    "attr": {
                        "fabricator": 33,
                        "door_range": 188,
                        "colour_range": 33,
                        "frame_colour_external": 1136,
                        "frame_colour_internal": 1136,
                        "door_colour_internal": 1,
                        "door_drip_colour": 1,
                        "external_colour": 1,
                        "frame_material": 1,
                        "hardware_colour": 45951,
                        "hardware_handle": 3687,
                        "hardware_hinge": 3699,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 3111,
                        "frame_style": {"frame_id": 1, "checkedPanels": []},
                        "laminated_glass": 2,
                        "hardware_lock": 3726,
                        "hardware_cylinder": 3677,
                        "hardware_security_chain": 317,
                        "hardware_hinge_bolts": 3978,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 144640664,
                        "threshold": 144640665,
                        "side_panels": {
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left": 1,
                            "right": 1,
                            "top_panel_glass_id": 10,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": 10,
                            "right_panel_glass_id": 10
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                        "cill": 144640669,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "glass_colours": null
                    }
                },
                189: {
                    "attr": {
                        "fabricator": 33,
                        "door_range": 189,
                        "colour_range": 34,
                        "frame_colour_external": 1149,
                        "frame_colour_internal": 1149,
                        "external_colour": 1181,
                        "door_colour_internal": 1181,
                        "door_drip_colour": 1,
                        "frame_material": 1,
                        "hardware_colour": 45951,
                        "hardware_handle": 3687,
                        "hardware_hinge": 3699,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 3157,
                        "frame_style": {"frame_id": 1, "checkedPanels": []},
                        "laminated_glass": 2,
                        "hardware_lock": 3726,
                        "hardware_cylinder": 3677,
                        "hardware_security_chain": 317,
                        "hardware_hinge_bolts": 3978,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 144640664,
                        "threshold": 144640665,
                        "side_panels": {
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left": 1,
                            "right": 1,
                            "top_panel_glass_id": 10,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": 10,
                            "right_panel_glass_id": 10
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                        "cill": 144640669,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "glass_colours": null
                    }
                },
                190: {
                    "attr": {
                        "fabricator": 33,
                        "door_range": 190,
                        "colour_range": 34,
                        "frame_colour_external": 1149,
                        "frame_colour_internal": 1149,
                        "external_colour": 1181,
                        "door_colour_internal": 1181,
                        "door_drip_colour": 1,
                        "frame_material": 1,
                        "hardware_colour": 45951,
                        "hardware_handle": 3687,
                        "hardware_hinge": 3699,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 3181,
                        "frame_style": {"frame_id": 1, "checkedPanels": []},
                        "laminated_glass": 2,
                        "hardware_lock": 3726,
                        "hardware_cylinder": 3677,
                        "hardware_security_chain": 317,
                        "hardware_hinge_bolts": 3978,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 144640664,
                        "threshold": 144640665,
                        "side_panels": {
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left": 1,
                            "right": 1,
                            "top_panel_glass_id": 10,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": 10,
                            "right_panel_glass_id": 10
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                        "cill": 144640669,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "glass_colours": null
                    }
                },
                191: {
                    "attr": {
                        "fabricator": 33,
                        "door_range": 191,
                        "colour_range": 34,
                        "frame_colour_external": 1149,
                        "frame_colour_internal": 1149,
                        "external_colour": 1181,
                        "door_colour_internal": 1181,
                        "door_drip_colour": 1,
                        "frame_material": 1,
                        "hardware_colour": 45951,
                        "hardware_handle": 3687,
                        "hardware_hinge": 3699,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 3163,
                        "frame_style": {"frame_id": 1, "checkedPanels": []},
                        "laminated_glass": 2,
                        "hardware_lock": 3726,
                        "hardware_cylinder": 3677,
                        "hardware_security_chain": 317,
                        "hardware_hinge_bolts": 3978,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 144640664,
                        "threshold": 144640665,
                        "side_panels": {
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left": 1,
                            "right": 1,
                            "top_panel_glass_id": 10,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": 10,
                            "right_panel_glass_id": 10
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                        "cill": 144640669,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "glass_colours": null
                    }
                },
                192: {
                    "attr": {
                        "fabricator": 33,
                        "door_range": 192,
                        "colour_range": 35,
                        "frame_colour_external": 82,
                        "frame_colour_internal": 82,
                        "door_colour_internal": 1,
                        "door_drip_colour": 1,
                        "external_colour": 1,
                        "frame_material": 99,
                        "hardware_colour": 45951,
                        "hardware_handle": 3687,
                        "hardware_hinge": 3699,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 3129,
                        "frame_style": {"frame_id": 65, "checkedPanels": []},
                        "laminated_glass": 2,
                        "hardware_lock": 3726,
                        "hardware_cylinder": 3677,
                        "hardware_security_chain": 317,
                        "hardware_hinge_bolts": 3978,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 120911,
                        "threshold": 120912,
                        "side_panels": {
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left": 1,
                            "right": 1,
                            "top_panel_glass_id": 10,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": 10,
                            "right_panel_glass_id": 10
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                        "cill": 144640669,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "glass_colours": null,
                    }
                },
                198: {
                    "attr": {
                        "fabricator": 33,
                        "door_range": 198,
                        "colour_range": 35,
                        "frame_colour_external": null,
                        "frame_colour_internal": null,
                        "door_colour_internal": 1,
                        "door_drip_colour": null,
                        "external_colour": 1,
                        "frame_material": 1,
                        "hardware_colour": 45951,
                        "hardware_handle": 3687,
                        "hardware_hinge": 3699,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 3086,
                        "frame_style": {"frame_id": 65, "checkedPanels": []},
                        "laminated_glass": 2,
                        "hardware_lock": 3726,
                        "hardware_cylinder": 3677,
                        "hardware_security_chain": 317,
                        "hardware_hinge_bolts": 3978,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 120911,
                        "threshold": 120912,
                        "side_panels": {
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left": 1,
                            "right": 1,
                            "top_panel_glass_id": null,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": null,
                            "right_panel_glass_id": null
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                        "cill": 144640669,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "glass_colours": null,
                        "glass_design": 1
                    }
                },
                199: {
                    "attr": {
                        "fabricator": 33,
                        "door_range": 199,
                        "colour_range": 35,
                        "frame_colour_external": null,
                        "frame_colour_internal": null,
                        "door_colour_internal": 1,
                        "door_drip_colour": null,
                        "external_colour": 1,
                        "frame_material": 1,
                        "hardware_colour": 45951,
                        "hardware_handle": 3687,
                        "hardware_hinge": 3699,
                        "hinge_side": 1,
                        "opening_direction": 1,
                        "secured_by_design": 1,
                        "slab": 3111,
                        "frame_style": {"frame_id": 65, "checkedPanels": []},
                        "laminated_glass": 2,
                        "hardware_lock": 3726,
                        "hardware_cylinder": 3677,
                        "hardware_security_chain": 317,
                        "hardware_hinge_bolts": 3978,
                        "hardware_letterbox": 318,
                        "hardware_knocker": 315,
                        "hardware_spy_hole": 316,
                        "profile": 120911,
                        "threshold": 120912,
                        "side_panels": {
                            "left_composite_id": null,
                            "right_composite_id": null,
                            "left": 1,
                            "right": 1,
                            "top_panel_glass_id": null,
                            "left_composite_glass_id": null,
                            "right_composite_glass_id": null,
                            "left_panel_glass_id": null,
                            "right_panel_glass_id": null
                        },
                        "numerals": [326, 326, 326, 326],
                        "addons": {"left": {}, "right": {}, "top": {}, "bottom": {}},
                        "cill": 144640669,
                        "notes": "",
                        "measurements": {
                            "overall_width": null,
                            "overall_height": null,
                            "left_width": null,
                            "right_width": null,
                            "top_box_drop": null
                        },
                        "glass_colours": null,
                        "glass_design": 1
                    }
                }
            };
        },
    }
}
</script>
